import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vClickOutside from 'v-click-outside'
import HighchartsVue from 'highcharts-vue'
import "ol/ol.css";
import "@/assets/style/map/index.css";

Vue.use(vClickOutside)


Vue.use(HighchartsVue)

//Axios
const axios = require('axios');
axios.defaults.withCredentials = true

// Respuesta global para axios si http code = 403 (backend lo entrega cuando no se encuentra la sesión).
// Los 403 de Terreno (auth/terrain_authz.go, terrain_session.go) siempre traen
// un "code" estructurado (TERRAIN_FORBIDDEN, TERRAIN_CSRF_INVALID, etc.) y no
// significan pérdida de sesión (el CSRF es recuperable con reintento); el 403
// legacy de auth.AuthSessionMiddleware nunca trae "code", solo "message".
const errorHandler = (error) => {
  if (error.response?.status === 403 && !error.response?.data?.code) {
    console.log('Sesión no encontrada')
    // Eliminar cookies públicas (cierra sesión)
    window.location.reload()
    document.cookie = "session_public" + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    $store.commit('setPermissions').bind(this);
    $router.push('/inicio').bind(this)
  }
  return Promise.reject(error)
}
const successHandler = (response) => {
  return response
}
axios.interceptors.response.use(
  response => successHandler(response),
  error => errorHandler(error)
)

Vue.prototype.$http = axios

//Validador global (español)
import VeeValidate, { Validator } from 'vee-validate';
import es from 'vee-validate/dist/locale/es'
import { isStrongPassword, strongPasswordMessage } from '@/utils/passwordPolicy.js'
Validator.localize({ es: es })
//Regla global de fortaleza de contraseña (TR-09) — misma política que
//PasswordRequirements.vue vía src/utils/passwordPolicy.js. El mensaje se
//registra también en el diccionario es (el locale activo resuelve desde ahí).
Validator.extend('strong_password', {
  getMessage: () => strongPasswordMessage,
  validate: (value) => isStrongPassword(value)
})
Validator.localize('es', { messages: { strong_password: () => strongPasswordMessage } })
Vue.use(VeeValidate, { locale: 'es' })

//FontAwesome icons
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'

//Shortkeys
Vue.use(require('vue-shortkey'))

import VueHtml2Canvas from 'vue-html2canvas';
Vue.use(VueHtml2Canvas);




import {
  faChevronDown,
  faChevronUp,
  faAngleDoubleLeft,
  faAngleLeft,
  faAngleRight,
  faAngleDoubleRight,
  faLayerGroup,
  faFileAlt,
  faQuestion,
  faToolbox,
  faFileImport,
  faRulerCombined,
  faBinoculars,
  faFileExport,
  faRuler,
  faMousePointer,
  faHandPointer,
  faChartBar,
  faChartPie,
  faSearch,
  faTimes,
  faMinus,
  faPlus,
  faMap,
  faChevronLeft,
  faArrowLeft,
  faChevronRight,
  faArrowUp,
  faArrowDown,
  faCogs,
  faCheck,
  faCopy,
  faStickyNote,
  faTrashAlt,
  faEllipsisH,
  faTable,
  faShare,
  faUpload,
  faListAlt,
  faPen,
  faPencilAlt,
  faSpinner,
  faExclamationTriangle,
  faTimesCircle,
  faInfoCircle,
  faDrawPolygon,
  faCircle,
  faMapMarkerAlt,
  faSort,
  faSortUp,
  faSortDown,
  faEye,
  faEyeSlash,
  faDownload,
  faFilter,
  faLocationArrow,
  faComment,
  faUndo,
  faRedo,
  faSignature,
  faFont,
  faDotCircle,
  faPrint,
  faBell,
  faUsers,
  faEraser,
  faExpand,
  faCompress,
  faSyncAlt,
  faBookmark,
  faCrosshairs,
  faCamera,
  faCloudUploadAlt,
  faImage,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFileCsv,
  faChevronCircleLeft,
  faChevronCircleRight,
  faExternalLinkAlt,
  faArrowsAltH,
} from '@fortawesome/free-solid-svg-icons'

library.add(
  faChevronDown,
  faChevronUp,
  faChevronLeft,
  faChevronRight,
  faArrowLeft,
  faAngleDoubleLeft,
  faAngleLeft,
  faAngleRight,
  faAngleDoubleRight,
  faLayerGroup,
  faFileAlt,
  faQuestion,
  faToolbox,
  faFileImport,
  faRulerCombined,
  faBinoculars,
  faFileExport,
  faRuler,
  faMousePointer,
  faHandPointer,
  faChartBar,
  faChartPie,
  faSearch,
  faTimes,
  faMinus,
  faPlus,
  faMap,
  faArrowUp,
  faArrowDown,
  faCogs,
  faCheck,
  faCopy,
  faStickyNote,
  faTrashAlt,
  faEllipsisH,
  faTable,
  faShare,
  faUpload,
  faShare,
  faUpload,
  faListAlt,
  faPen,
  faPencilAlt,
  faSpinner,
  faExclamationTriangle,
  faTimesCircle,
  faInfoCircle,
  faDrawPolygon,
  faCircle,
  faMapMarkerAlt,
  faMousePointer,
  faSort,
  faSortUp,
  faSortDown,
  faEye,
  faEyeSlash,
  faDownload,
  faFilter,
  faLocationArrow,
  faComment,
  faUndo,
  faRedo,
  faSignature,
  faFont,
  faDotCircle,
  faPrint,
  faBell,
  faUsers,
  faEraser,
  faExpand,
  faCompress,
  faSyncAlt,
  faBookmark,
  faCrosshairs,
  faCamera,
  faCloudUploadAlt,
  faImage,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFileCsv,
  faChevronCircleLeft,
  faChevronCircleRight,
  faExternalLinkAlt,
  faArrowsAltH,
)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('font-awesome-layers', FontAwesomeLayers)
Vue.component('font-awesome-layers-text', FontAwesomeLayersText)

//Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);

//Modal
import VModal from 'vue-js-modal';
// injectModalsContainer: sin esto, this.$modal.show(Component, ...) (modales
// dinámicos, usados por AttachmentGallery.vue) no tiene dónde montarse — la
// app no declara <modals-container/> en ningún template propio.
Vue.use(VModal, { dialog: true, dynamic: true, injectModalsContainer: true });

//Gráficos
import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)

//Estilos (s)css
require("./assets/style/style.scss");
require("./assets/style/style-error.scss");
require("./assets/style/style-modal.scss");
require("./assets/style/style-map-tools-windows.scss");

// Estilos mapas
require("./assets/style/mapStyle/map.scss");
require("./assets/style/mapStyle/map-controls.css");
require("./assets/style/mapStyle/map-controls-icons.css");
require("./assets/style/mapStyle/map-tools.css");
require("./assets/style/mapStyle/map-popover.css");
//require("./assets/style/fontawesome/css/all.css"); //Producción

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
